
    import('./src/main.ts').then(() => window.__boot.ready(), error => window.__boot.fail(error));
  